module.exports = __webpack_public_path__ + "media/images/cardboard-img-05-c7c3fbb1e0fb108db9d7aa2d21cfdbfe.jpg";